var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActticktes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "url(#paint0_linear_120_1995)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_120_1995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 11C29.2652 11 29.5196 11.1054 29.7071 11.2929C29.8946 11.4804 30 11.7348 30 12V17.5C29.337 17.5 28.7011 17.7634 28.2322 18.2322C27.7634 18.7011 27.5 19.337 27.5 20C27.5 20.663 27.7634 21.2989 28.2322 21.7678C28.7011 22.2366 29.337 22.5 30 22.5V28C30 28.2652 29.8946 28.5196 29.7071 28.7071C29.5196 28.8946 29.2652 29 29 29H11C10.7348 29 10.4804 28.8946 10.2929 28.7071C10.1054 28.5196 10 28.2652 10 28V22.5C10.663 22.5 11.2989 22.2366 11.7678 21.7678C12.2366 21.2989 12.5 20.663 12.5 20C12.5 19.337 12.2366 18.7011 11.7678 18.2322C11.2989 17.7634 10.663 17.5 10 17.5V12C10 11.7348 10.1054 11.4804 10.2929 11.2929C10.4804 11.1054 10.7348 11 11 11H29ZM24 17H16V23H24V17Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_120_1995",
    x1: 0,
    y1: 0,
    x2: 46.1024,
    y2: 9.10665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EEAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#6E38FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F600FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_120_1995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActticktes);
export default __webpack_public_path__ + "static/media/actticktes.0f89283ca72771b9c0a4a0370301b1e1.svg";
export { ForwardRef as ReactComponent };